exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".boldStyle{font-weight:bold}.row{width:100%;display:flex;justify-content:space-between}.infoWindowColumnOne{text-align:left}.infoWindowColumnTwo{text-align:right;margin:0px 16px 0px 16px}.icon{font-size:small}.infoWindow{font-size:x-small;padding-right:16px}\n", ""]);

// exports
